export default __webpack_public_path__ + "static/media/pathway-done.a1b32e27.png";